<template>
  <text-item v-if="item.el === undefined || item.el === 'text'" :it="item" :model="model" />
  <!-- eslint-disable-next-line vue/no-unused-refs -->
  <form-item ref="formItem" v-else :it="item" :model="model">
    <span slot="labelTip" v-if="item.itemConfig.labelTip">
      <el-tooltip placement="top">
        <div slot="content" v-html="item.itemConfig.labelTip.content" />
        <i class="el-icon-warning" />
      </el-tooltip>
    </span>
  </form-item>
</template>

<script>
export default {
  name: 'FormTextGenerator',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    model: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
}
</script>

<style>

</style>
